<template>
  <div class="ibox float-e-margins sec-skeleton">
    <div class="ibox-title">
      <span class="sec-skeleton__bar sec-skeleton__bar--title"></span>
    </div>
    <div class="ibox-content" :style="{ minHeight: `${height}px` }">
      <span class="sec-skeleton__bar sec-skeleton__bar--line"></span>
      <div class="sec-skeleton__grid">
        <span v-for="n in blocks" :key="n" class="sec-skeleton__block"></span>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * A card-shaped placeholder with shimmering blocks, shown in the place of a
 * dashboard section while its code is still being downloaded, so the page
 * never shows an empty gap.
 *
 * Note: `height` should be about the height of the real section, so the page
 * does not jump when the section appears.
 */
export default {
  name: 'SectionSkeleton',
  props: {
    height: { type: Number, default: 280 },
    blocks: { type: Number, default: 4 },
  },
};
</script>

<style lang="scss" scoped>
.sec-skeleton {
  &__bar,
  &__block {
    display: block;
    background: linear-gradient(90deg, #f3f3f4 25%, #fafafa 50%, #f3f3f4 75%);
    background-size: 200% 100%;
    border-radius: 6px;
    animation: sec-skeleton-shimmer 1.2s linear infinite;
  }

  &__bar--title {
    height: 16px;
    width: 180px;
  }

  &__bar--line {
    height: 14px;
    width: 55%;
    margin-bottom: 18px;
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 14px;
  }

  &__block {
    height: 120px;
  }
}

@keyframes sec-skeleton-shimmer {
  from {
    background-position: 200% 0;
  }
  to {
    background-position: -200% 0;
  }
}
</style>



// WEBPACK FOOTER //
// SectionSkeleton.vue?b077dbee